import { Routes } from '@angular/router';
import { LoginComponent } from './components/login/login.component';
import { CallbackComponent } from './components/callback/callback.component';
import { authGuard } from '../guards/auth.guard';

export const routes: Routes = [
  {
    path: '',
    redirectTo: '/login',
    pathMatch: 'full'
  },
  {
    path: 'login',
    component: LoginComponent
  },
  {
    path: 'login/callback',
    component: CallbackComponent
  },
  {
    path: 'home',
    canActivate: [authGuard],
    children: []
  },
  {
    path: '**',
    redirectTo: '/login'
  }
];
